import "./userList.css";
import { DataGrid } from "@material-ui/data-grid";
import { Edit } from "@material-ui/icons";
// import { DeleteOutline, Edit } from "@material-ui/icons";
import { Link } from "react-router-dom";
import { useState, useEffect } from "react";
import Navbar from "../../components/navbar/Navbar";
import AdminService from "../../services/admin.service";
import Preloader from "../../components/preloader/Preloader";

export default function UserList() {
	const [userData, setUserData] = useState([]);
	const [fetching, setFetching] = useState(false);
	const [pageSize, setPageSize] = useState(10);

	// const handleDelete = (e, id) => {
	// 	e.preventDefault();
	// 	AdminService.deleteUser(id);
	// 	window.location.reload(true);
	// };

	const getUsers = async () => {
		setFetching(true);
		let res = await AdminService.getAllUser();
		const data = res.allUsers;
		setUserData(data);
		setFetching(false);
	};

	useEffect(() => {
		getUsers();
	}, []);

	const columns = [
		{ field: "_id", headerName: "ID", width: 100 },
		{
			field: "staffnum",
			headerName: "STAFF NUMBER",
			width: 200,
			valueGetter: (params) => `${params.row.staffnum.toUpperCase()}`,
		},
		{
			field: "firstname",
			headerName: "First Name",
			width: 200,
			valueGetter: (params) => `${params.row.firstname.toUpperCase()}`,
		},
		{
			field: "middlename",
			headerName: "Middle Name",
			width: 200,
			valueGetter: (params) => `${params.row.middlename.toUpperCase()}`,
		},
		{
			field: "lastname",
			headerName: "Last Name",
			width: 200,
			valueGetter: (params) => `${params.row.lastname.toUpperCase()}`,
		},
		{ field: "email", headerName: "Email", width: 200 },
		{
			field: "active",
			headerName: "Active",
			width: 120,
			valueGetter: (params) => `${params.row.active === true ? "Yes" : "No"}`,
		},
		{
			field: "action",
			headerName: "Action",
			width: 120,
			renderCell: (params) => {
				return (
					<>
						<Link to={"/admin/user/" + params.row._id}>
							<Edit className="userListEdit" />
						</Link>
						{/* <DeleteOutline
							className="userListDelete"
							onClick={(e) => handleDelete(e, params.row._id)}
						/> */}
					</>
				);
			},
		},
	];

	return (
		<>
			<Navbar />
			<div className="userList" style={{ height: 500, width: "100%" }}>
				{userData && (
					<DataGrid
						getRowId={(row) => row._id}
						rows={userData}
						columns={columns}
						pageSize={pageSize}
						onPageSizeChange={(newPageSize) => setPageSize(newPageSize)}
						rowsPerPageOptions={[10, 15, 20]}
						pagination
					/>
				)}
			</div>
			{fetching && <Preloader text={"Fetching data"} />}
		</>
	);
}
